import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Menu, Tooltip } from "@mui/material";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@material-ui/core/TextField";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import Pagination from "../pagination/Pagination";
import "./RecipientsList.css";
import {
  GetConversation_Url,
  GetMessageActivityContacts_Url,
  SendSimulatedReponseMessage_Url,
} from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import PtsAlert from "../ptsAlert/PtsAlert";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
// import RemoveContactButton from "../buttons/RemoveContactButton";
import _ from "lodash";
import RemoveContactButton from "../buttons/RemoveContactButton";
import PaginationRowAction from "../../../redux/paginationRow/PaginationRowAction";
import UserInvalid from "../../../assets/img/user-invalid-icon.png";

class RecipientsList extends Component {
  header = store.getState().header.header;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  paginationState = store.getState().paginations?.outgoingMsgState;
  givbeeBreadCrumb = [
    { pageid: "/sendHistory", uiname: "Send History" },
    { pageid: "", uiname: "Recipients List" },
  ];
  eventBreadCrumb = [
    { pageid: "/eventSendHistory", uiname: "Send History" },
    { pageid: "", uiname: "Recipients List" },
  ];
  dptextBreadCrumb = [
    { pageid: "/dptextSendHistory", uiname: "Send History" },
    { pageid: "", uiname: "Recipients List" },
  ];
  givbeeScheduledBreadCrumb = [
    { pageid: "/scheduledSends", uiname: "Scheduled Sends" },
    { pageid: "", uiname: "Recipients List" },
  ];
  eventScheduledBreadCrumb = [
    { pageid: "/eventScheduledSends", uiname: "Scheduled Sends" },
    { pageid: "", uiname: "Recipients List" },
  ];
  dptextScheduledBreadCrumb = [
    { pageid: "/dptextScheduledSends", uiname: "Scheduled Sends" },
    { pageid: "", uiname: "Recipients List" },
  ];
  title = "View details for scheduled send";
  paginationStateDetails = {};
  constructor(props) {
    super(props);
    let pageId = "";
    let smsMessageLog = null;
    if (props.state) {
      pageId = props.state.pageId;
      smsMessageLog = props.state.smsMessageLog;
    }
    let breadCrumb = [];
    if (pageId === "sendHistory") {
      if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
        breadCrumb = this.eventBreadCrumb;
      } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
        breadCrumb = this.dptextBreadCrumb;
      } else {
        breadCrumb = this.givbeeBreadCrumb;
      }
    } else {
      if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
        breadCrumb = this.eventScheduledBreadCrumb;
      } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
        breadCrumb = this.dptextScheduledBreadCrumb;
      } else {
        breadCrumb = this.givbeeScheduledBreadCrumb;
      }
    }

    if (this.paginationState) {
      this.paginationStateDetails = Object.getOwnPropertyNames(
        this.paginationState
      );
    }
    this.state = {
      breadCrumb: breadCrumb,
      searchText: "",
      responseMessage: "",
      contactMessageLogId: "",
      textMessage: "",
      initialPage: 0,
      pageSize:
        this.paginationStateDetails?.length > 0
          ? this.paginationState?.pageSize
          : 100,
      MessageActivityContactList: [],
      conversationList: [],
      id: smsMessageLog?.id,
      pageId: pageId,
      messageName: smsMessageLog?.messageName,
      messageType: smsMessageLog?.messageType,
      isFailedResend: smsMessageLog?.isFailedResend,
      sortColumn: this.paginationStateDetails?.length > 0
        ? this.paginationState?.sortColumn : null,
      isAscSort: this.paginationStateDetails?.length > 0
        ? this.paginationState?.isAscSort : false,
      anchorEl: null,
      anchorE2: null,
      open: false,
      openConversation: false,
      getDeletePermission: false,
      render: false,
    };
    this.getRecipientList();
    this.debouncedSearch = _.debounce(this.getRecipientList, 800);
  }

  getRecipientList(pageNo, pageSize, sortBy, isAscSort) {
    const postObject = {
      header: this.header,
      messageLog: {
        id: this.state.id,
        event: {
          id: this.businessDomainId,
        },
      },
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo ? pageNo : this.state.initialPage,
        pageSize: pageSize ? pageSize : this.state.pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
    };

    FetchServerData.callPostService(
      GetMessageActivityContacts_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let MessageActivityContactList = output.data.logList;
        let page = output.data.page;
        for (let i = 0; i < MessageActivityContactList.length; i++) {
          MessageActivityContactList[i].mobile =
            Utils.viewTollFreeNumberFormate(
              MessageActivityContactList[i].mobile
            );
          MessageActivityContactList[i].createdOn = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventTimezone(MessageActivityContactList[i].createdOn, true) : Utils.getUtcToLocalDateTimeZone(
            MessageActivityContactList[i].createdOn, true
          );
          MessageActivityContactList[i].scheduledDate = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventTimezone(MessageActivityContactList[i].scheduledDate, true) :
            Utils.getUtcToLocalDateTimeZone(
              MessageActivityContactList[i].scheduledDate, true
            );
        }

        let getPermission = Utils.getRolePermission(
          output.data?.privilegeList
        );
        let getDeletePermission = getPermission[4];
        this.setState({
          render: true,
          MessageActivityContactList: MessageActivityContactList,
          pageNo: page.pageNo,
          showPerPage: page.pageSize,
          totalPages: page.totalPages,
          totalRecords: page.total,
          getDeletePermission: getDeletePermission,
        });
      } else {
      }
    });
  }



  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    const outgoingMsgState = {
      pageSize: pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      PaginationRowAction.setRecipientsPaginationState({ outgoingMsgState })
    );
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.setState({
      pageNo: currentPageIndex,
      pageSize: pageSize,
    });
    this.getRecipientList(currentPageIndex, pageSize, this.state.sortColumn, this.state.isAscSort);
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  viewCancel() {
    if (this.state.pageId === "sendHistory") {
      if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
        this.props.navigate("/eventSendHistory");
      } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
        this.props.navigate("/dptextSendHistory");
      } else {
        this.props.navigate("/sendHistory");
      }
    } else {
      if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
        this.props.navigate("/eventScheduledSends");
      } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
        this.props.navigate("/dptextScheduledSends");
      } else {
        this.props.navigate("/scheduledSends");
      }
    }
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(this.state.pageNo, this.state.pageSize);
  }

  handleResponseMessageChange(e) {
    this.setState({
      responseMessage: e.target.value,
    });
  }
  handleDialogOpen(e, rowData) {
    this.setState({
      open: true,
      anchorEl: e.currentTarget,
      textMessage: rowData.textMessage,
      contactMessageLogId: rowData.id,
    });
  }
  handleDialogClose() {
    this.setState({
      open: false,
      anchorEl: null,
    });
  }

  getConversationDetails(rowData) {
    const postObject = {
      header: this.header,
      twilioSmsLog: { id: rowData.id },
    };

    FetchServerData.callPostService(GetConversation_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let conversationList = output.data.conversationList;
          for (let i = 0; i < conversationList.length; i++) {
            conversationList[i].createdOn = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventTimezone(conversationList[i].createdOn, true) :
              Utils.getUtcToLocalDateTimeZone(
                conversationList[i].createdOn, true
              );
          }
          this.setState({
            render: true,
            conversationList: conversationList,
          });
        } else {
        }
      }
    );
  }

  handleConversationDialogOpen(e, rowData) {
    this.getConversationDetails(rowData);
    this.setState({
      openConversation: true,
      anchorE2: e.currentTarget,
      mobile: rowData.mobile,
      firstName: rowData.firstName,
      lastName: rowData.lastName,
    });
  }

  handleConversationDialogClose() {
    this.setState({
      openConversation: false,
      anchorE2: null,
    });
  }

  sendResponseMessage() {
    const postObject = {
      header: this.header,
      contactMessageLogId: this.state.contactMessageLogId,
      responseMessage: this.state.responseMessage,
    };

    FetchServerData.callPostService(
      SendSimulatedReponseMessage_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.getRecipientList(this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
        this.setState({
          render: true,
          open: false,
          responseMessage: "",
        });
      } else {
      }
    });
  }

  removeContactFromActivitiy(data) {
    const postObject = {
      header: this.header,
      messageLog: { id: data.messageLogId },
      contactId: data.contactId,
    };

    FetchServerData.callPostService(
      "/messageLogms/removeContactFromMsgLog",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getRecipientList(this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
        } else {
        }
      })
      .catch((error) => { });
  }

  recipientTitle() {
    return (
      <>
        {this.state.pageId === "sendHistory"
          ? "View details for text message send"
          : "View details for scheduled send"}
        :
        <span className="ms-1" style={{ color: "#337ab7" }}>
          {this.state.messageName}
        </span>
      </>
    );
  }

  convertToLink = (text) => {
    return text?.split(/\s+/)?.map((word, index) => {
      const trimmedWord = word?.trim();
      const urlPattern = /^(https?:\/\/[^\s]+)$/;
      const match = trimmedWord?.match(urlPattern);

      if (match) {
        // Remove trailing punctuation from the URL
        const cleanUrl = trimmedWord?.replace(/[.,!?;:]+$/, "");
        const trailingPunctuation = trimmedWord?.slice(cleanUrl.length);

        return (
          <React.Fragment key={index}>
            <a
              className="p-0 anchortag"
              href={cleanUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {cleanUrl}
            </a>
            {trailingPunctuation + " "}
          </React.Fragment>
        );
      } else {
        return trimmedWord + " ";
      }
    });
  };

  // handleSort(column) {
  //   const { sortColumn, sortDirection, MessageActivityContactList } =
  //     this.state;
  //   let newDirection = "asc";

  //   if (sortColumn === column && sortDirection === "asc") {
  //     newDirection = "desc";
  //   }

  //   this.setState({
  //     MessageActivityContactList: Utils.sortList(
  //       MessageActivityContactList,
  //       column,
  //       newDirection
  //     ),
  //     sortColumn: column,
  //     sortDirection: newDirection,
  //   });
  // }

  handleSort(column) {
    const { sortColumn, sortDirection, pageNo, pageSize } = this.state;
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";

    const isAscSort = newDirection === "asc";

    const outgoingMsgState = {
      pageSize: pageSize,
      sortColumn: column,
      isAscSort: isAscSort,
    };
    store.dispatch(
      PaginationRowAction.setSendHistoryPaginationState({ outgoingMsgState })
    );
    this.setState(
      {
        sortColumn: column,
        sortDirection: newDirection,
        isAscSort: isAscSort
      },
      () => {
        this.getRecipientList(pageNo, pageSize, column, isAscSort);
      }
    );
  }

  allResendToFailedNumber(e) {
    const postObject = {
      header: this.header,
      outgoingLogId: null,
      messageLogId: this.state.id,
      sendToAllFailed: true,
    };

    FetchServerData.callPostService("/twilioms/resendSmsToFailed", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          if (this.state.pageId === "sendHistory") {
            if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
              this.props.navigate("/eventSendHistory");
            } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
              this.props.navigate("/dptextSendHistory");
            } else {
              this.props.navigate("/sendHistory");
            }
          } else {
            if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
              this.props.navigate("/eventScheduledSends");
            } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
              this.props.navigate("/dptextScheduledSends");
            } else {
              this.props.navigate("/scheduledSends");
            }
          }
        } else {
        }
      })
      .catch((error) => { });
  }

  resendToFailedNumber(e, data) {
    const postObject = {
      header: this.header,
      outgoingLogId: data?.id,
      // failedContactId: data.contactId,
      // sendToAllFailed: false,
    };

    FetchServerData.callPostService("/twilioms/resendSmsToFailed", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          if (this.state.pageId === "sendHistory") {
            if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
              this.props.navigate("/eventSendHistory");
            } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
              this.props.navigate("/dptextSendHistory");
            } else {
              this.props.navigate("/sendHistory");
            }
          } else {
            if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
              this.props.navigate("/eventScheduledSends");
            } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
              this.props.navigate("/dptextScheduledSends");
            } else {
              this.props.navigate("/scheduledSends");
            }
          }
        } else {
        }
      })
      .catch((error) => { });
  }

  markInvalidNumber(e, data) {
    const postObject = {
      header: this.header,
      outgoingSmsLogId: data.id,
    };

    FetchServerData.callPostService("/smscontactms/markInvalid", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getRecipientList(this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
        } else {
        }
      })
      .catch((error) => { });
  }

  componentDidMount() {
    this.scrollToBottom();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.conversationList !== this.state.conversationList) {
      this.scrollToBottom();
    }
  }

  scrollToBottom = () => {
    if (this.chatContainer) {
      this.chatContainer.scrollTop = this.chatContainer.scrollHeight;
    }
  };


  render() {
    const isTextResponse = process.env.REACT_APP_ENABLE_MANUAL_RESPONSE === "true";
    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.state.breadCrumb}
          history={this.props.history}
          backCallback={this.viewCancel.bind(this)}
          name={this.recipientTitle()}
          isSearchText={this.state.searchText !== ""}
        />
        <div className="row">
          <div className="col">
            <div className="col md-12 mt-2">
              <div className="card rounded-0">
                <div className="row justify-content-between p-2">
                  <div className="d-flex col-12 col-lg-5 col-xl-5">
                    <div className="col-12 text-start totalResults">
                      <span>Total Contacts: {Utils.formatWithCommas(this.state.totalRecords)}</span>
                    </div>
                  </div>
                  <div className="d-flex col-12 col-lg-7 col-xl-7">
                    <div className="col-12 text-end">
                      {this.state.isFailedResend && (
                        <span className="me-2">
                          <Tooltip
                            arrow
                            title="This will resend to numbers that have details “Undelivered. Reason unknown“."
                            classes={{
                              popper: "custom-tooltip",
                            }}
                          >
                            <Button
                              id="ptsHollowButton"
                              style={{ textTransform: "initial" }}
                              variant="contained"
                              className="btn btn-default "
                              onClick={(e) => this.allResendToFailedNumber(e)}
                            >
                              Retry failed numbers
                            </Button>
                          </Tooltip>
                        </span>
                      )}
                      <TextField
                        id="standard-search"
                        placeholder="Search"
                        type="text"
                        variant="standard"
                        value={this.state.searchText}
                        onChange={this.onSearchChange.bind(this)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <IconButton
                                onClick={this.getRecipientList.bind(
                                  this,
                                  this.state.pageNo,
                                  this.state.pageSize,
                                  this.state.sortColumn,
                                  this.state.isAscSort
                                )}
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => {
                                  this.setState({ searchText: "" }, () => {
                                    this.getRecipientList(
                                      this.state.pageNo,
                                      this.state.pageSize, this.state.sortColumn, this.state.isAscSort
                                    );
                                  });
                                }}
                                disabled={!this.state.searchText}
                              >
                                <ClearIcon
                                  style={{
                                    opacity: this.state.searchText ? 1 : 0.4,
                                    fontSize: "1.25rem",
                                    color: "353538",
                                  }}
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="table-responsive paginationTable">
                  <table className="table text-start table-hover">
                    <thead className="paginationTableThead">
                      <tr>
                        <th className="cursor-pointer"
                          scope="col fw-bold" onClick={() => this.handleSort("mobile")}>
                          Mobile Number
                          {this.state.sortColumn === "mobile" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}</th>
                        <th
                          className="cursor-pointer"
                          scope="col fw-bold"
                          onClick={() => this.handleSort("firstName")}
                        >
                          First Name
                          {this.state.sortColumn === "firstName" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th
                          className="cursor-pointer"
                          scope="col fw-bold"
                          onClick={() => this.handleSort("lastName")}
                        >
                          Last Name
                          {this.state.sortColumn === "lastName" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th
                          className="cursor-pointer"
                          scope="col fw-bold"
                          onClick={() => this.handleSort("email")}
                        >
                          Email
                          {this.state.sortColumn === "email" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th className="cursor-pointer"
                          scope="col fw-bold">
                          {this.state.pageId !== "sendHistory"
                            ? "Scheduled Date/Time"
                            : "Delivery Date/Time"}
                          {this.state.sortColumn === "lastName" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th
                          className="cursor-pointer"
                          scope="col fw-bold"
                          onClick={() => this.handleSort("deliveryStatus")}
                        >
                          Status
                          {this.state.sortColumn === "deliveryStatus" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th
                          className="cursor-pointer"
                          scope="col fw-bold"
                          onClick={() => this.handleSort("errorMessage")}
                        >
                          Details
                          {this.state.sortColumn === "errorMessage" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th
                          scope="col fw-bold text-center"
                          style={{ textAlign: "center" }}
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.MessageActivityContactList?.map(
                        (rowData, index) => (
                          <tr key={index}>
                            <td style={{ width: "190px" }}>{rowData.mobile}</td>
                            <td style={{ width: "140px" }}>
                              {rowData.firstName}
                            </td>
                            <td style={{ width: "140px" }}>
                              {rowData.lastName}
                            </td>
                            <td style={{ width: "200px" }}>{Utils.truncateString(rowData.email, 28)}</td>
                            <td style={{ width: "270px" }}>
                              {this.state.pageId !== "sendHistory"
                                ? rowData.scheduledDate
                                : rowData.createdOn}
                            </td>
                            <td style={{ width: "140px" }}>
                              {rowData.deliveryStatus}
                            </td>
                            <td style={{ width: "250px" }}>
                              {rowData.errorMessage}
                            </td>
                            <td style={{ width: "170px" }}>
                              <div className="row d-flex justify-content-center">
                                {this.state.getDeletePermission && this.state.pageId !== "sendHistory" && (
                                  <div className="col-sm-3 p-0 text-center">
                                    <div
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        textAlign: "center",
                                      }}
                                    >
                                      {rowData.deliveryStatus === "Scheduled" &&
                                        <span style={{ cursor: "pointer" }}>
                                          <RemoveContactButton
                                            domainObject={rowData.mobile}
                                            onClick={this.removeContactFromActivitiy.bind(
                                              this,
                                              rowData
                                            )}
                                            pageId="Recipient"
                                          />
                                        </span>
                                      }
                                    </div>
                                  </div>
                                )}
                                <div className="col-sm-3 p-0 text-center">
                                  <div
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      textAlign: "center",
                                    }}
                                  >
                                    {rowData.canResend && (
                                      <span
                                        className="anchortag action-text"
                                        onClick={(e) =>
                                          this.resendToFailedNumber(e, rowData)
                                        }
                                      >
                                        Retry
                                      </span>
                                    )}
                                    {rowData.isRetried && (
                                      <span>
                                        Retried
                                      </span>
                                    )}
                                    {rowData.canMarkInvalid && (
                                      <span
                                        style={{
                                          cursor: "pointer",
                                        }}
                                      >
                                        <Tooltip
                                          title="Mark as Invalid Number. Remove from all groups & lists. Do not send texts."
                                          classes={{ popper: "custom-tooltip" }}
                                          arrow
                                        >
                                          <img
                                            src={UserInvalid}
                                            style={{
                                              width: "22.5px",
                                              height: "22.5px",
                                            }}
                                            alt="Fundraising Meter"
                                            onClick={(e) =>
                                              this.markInvalidNumber(e, rowData)
                                            }
                                          />
                                        </Tooltip>
                                      </span>
                                    )}
                                    {(!rowData.canMarkInvalid && rowData.contactStatus === "InvalidNumber") && (
                                      <Tooltip
                                        title="This number is invalid. It has been deleted from all Groups and Lists."
                                        classes={{ popper: "custom-tooltip" }}
                                        arrow
                                      >
                                        <span style={{ opacity: 0.4, cursor: "pointer", display: "inline-block" }}>
                                          <img
                                            src={UserInvalid}
                                            style={{
                                              pointerEvents: "none",
                                              width: "22.5px",
                                              height: "22.5px",
                                            }}
                                            alt="Invalid User"
                                          />
                                        </span>
                                      </Tooltip>
                                    )}
                                  </div>
                                </div>
                                <div
                                  className="col-sm-3 ps-2 pe-2"
                                  style={{
                                    alignSelf: "center",
                                    textAlign: "center",
                                  }}
                                >
                                  <Tooltip
                                    title="Text history"
                                    classes={{ popper: "custom-tooltip" }}
                                    arrow
                                  >
                                    <span>
                                      <QuestionAnswerIcon
                                        onClick={(e) =>
                                          this.handleConversationDialogOpen(
                                            e,
                                            rowData
                                          )
                                        }
                                        style={{
                                          color: "#4b8bd3",
                                          fontSize: "18px",
                                          cursor: "pointer",
                                        }}
                                      />
                                    </span>
                                  </Tooltip>
                                </div>
                                <div
                                  className="col-sm-3 text-center ps-1 pe-2"
                                  style={{
                                    alignSelf: "center",
                                    textAlign: "center",
                                  }}
                                >
                                  {isTextResponse && (
                                    <div
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <span
                                        className="anchortag"
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "x-larger",
                                          alignItems: "center",
                                          borderRadius: "60%",
                                          border: "solid 1px #6A7B8E",
                                          padding: "0px 6px",
                                        }}
                                        onClick={(e) =>
                                          this.handleDialogOpen(e, rowData)
                                        }
                                      >
                                        R
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
                {this.state.totalRecords === 0 && (
                  <div
                    className="row text-center"
                    style={{ padding: "6px 20px" }}
                  >
                    <h5 className="dataNotAvailable">No data found.</h5>
                  </div>
                )}
                {this.state.totalRecords > 10 && (
                  <div className="row justify-content-between pagination p-1">
                    <div className="d-flex col-12 col-lg-4 col-xl-4">
                      <div className="pageSize col-12 text-start">
                        Page {this.state.pageNo + 1} of {this.state.totalPages}
                      </div>
                    </div>
                    <div className="d-flex col-12 col-lg-8 col-xl-8">
                      <div className="col-12 text-end">
                        <Pagination
                          showPerPage={this.state.showPerPage}
                          onPaginationChange={this.onPaginationChange.bind(
                            this
                          )}
                          total={this.state.totalRecords}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <Dialog
          anchorEl={this.state.anchorE2}
          id="dropdown-menu1"
          className="RecipientDialog"
          open={this.state.openConversation}
          onClose={this.handleConversationDialogClose.bind(this)}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 20,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <IconButton
            aria-label="close"
            onClick={this.handleConversationDialogClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#000", fontWeight: "600" }} />
          </IconButton>
          <div
            className="dropdown-item"
            style={{ cursor: "pointer", height: "100%" }}
          >
            <div className="row">
              <div className="col-md-12">
                <label
                  htmlFor="exampleFormControlTextarea1"
                  className="form-label fs-6"
                >
                  {`${this.state.mobile || ""} ${this.state.firstName || this.state.lastName
                    ? ` (${[this.state.firstName, this.state.lastName]?.filter(Boolean)?.join(" ")})`
                    : ""
                    }`}
                </label><br></br>
                <label
                  htmlFor="exampleFormControlTextarea1"
                  className="form-label fs-6"
                >
                  {`Text history for: ${this.state.messageName || ""}`}
                </label>
              </div>
              <hr className="m-0"></hr>
            </div>
            <div
              className="row p-3"
              style={{ height: "100%", overflowY: "scroll" }}
              ref={(el) => (this.chatContainer = el)}
            >
              <div className="col-md-12">
                {this.state.conversationList.map((rowData, index) => (
                  <>
                    {rowData.direction === "Out" ? (
                      <>
                        {rowData.textMessage !== "" && (
                          <div className="row mb-3">
                            <div className="col-md-9">
                              <div
                                className="row"
                                style={{
                                  backgroundColor: "#daebfb",
                                  padding: "5px 10px",
                                  color: "#000",
                                  borderRadius: "5px",
                                  display: "inline-block",
                                  whiteSpace: "pre-line",
                                  fontSize: "14px",
                                }}
                              >
                                {this.convertToLink(rowData.textMessage)}
                                <span
                                  className="align-item-end p-0"
                                  style={{
                                    display: "inline-block",
                                    whiteSpace: "pre-line",
                                    textAlign: "right",
                                    fontSize: "10px",
                                  }}
                                >
                                  {rowData.createdOn}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="row justify-content-end mb-3">
                        <div className="col-md-9 text-end">
                          <div
                            className="row"
                            style={{
                              backgroundColor: "#d3d8de",
                              padding: "5px 10px",
                              color: "#000",
                              borderRadius: "5px",
                              display: "inline-block",
                              whiteSpace: "pre-line",
                              textAlign: "start",
                            }}
                          >
                            {rowData.textMessage}
                            <br />
                            <span
                              className="align-item-end p-0"
                              style={{
                                display: "inline-block",
                                whiteSpace: "pre-line",
                                textAlign: "right",
                                fontSize: "10px",
                              }}
                            >
                              {rowData.createdOn}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ))}
              </div>
            </div>
          </div>
        </Dialog>
        <Menu
          anchorEl={this.state.anchorEl}
          id="dropdown-menu1"
          className="filterDropdownMenu"
          open={this.state.open}
          onClose={this.handleDialogClose.bind(this)}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 20,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <IconButton
            aria-label="close"
            onClick={this.handleDialogClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#000", fontWeight: "600" }} />
          </IconButton>
          <div
            className="dropdown-item"
            style={{ cursor: "pointer", width: "400px", height: "100%" }}
          >
            <div className="row mt-3">
              <label
                htmlFor="exampleFormControlTextarea1"
                className="form-label text-wrap"
              >
                {this.state.textMessage}
              </label>
              <div className="col-md-12">
                <textarea
                  title=""
                  required
                  type="text"
                  value={this.state.responseMessage}
                  onChange={this.handleResponseMessageChange.bind(this)}
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                />
              </div>
            </div>
            <div
              className="row pt-4 pb-3 text-center"
              style={{ float: "right" }}
            >
              <div className="col-md-12">
                <Button
                  type="button"
                  variant="contained"
                  size="small"
                  style={{
                    background: "#37517e",
                    color: "white",
                    width: "130px",
                    cursor: "pointer",
                    borderRadius: "5px",
                    textTransform: "capitalize",
                    fontWeight: "600",
                  }}
                  onClick={this.sendResponseMessage.bind(this)}
                >
                  Send Response
                </Button>
              </div>
            </div>
          </div>
        </Menu>
      </>
    );
  }
}

export default withRouter(RecipientsList);
